import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
export const useRecentNetworksStore = create()(persist((set) => ({
    recentRoutes: {
        sourceRoutes: {},
        destinationRoutes: {},
    },
    updateRecentNetworks: (args) => {
        set(state => ({
            recentRoutes: updateRecentNetworksHelper(state.recentRoutes, args)
        }));
    }
}), {
    name: 'recentRoutes',
    storage: createJSONStorage(() => localStorage),
}));
const updateRecentNetworksHelper = (prev, data) => {
    const { from, to } = data;
    return {
        sourceRoutes: {
            ...prev.sourceRoutes,
            ...(from ? {
                [from.network]: {
                    ...prev.sourceRoutes[from.network],
                    [from.token]: (prev.sourceRoutes?.[from.network]?.[from.token] || 0) + 1
                }
            } : {})
        },
        destinationRoutes: {
            ...prev.destinationRoutes,
            [to.network]: {
                ...prev.destinationRoutes[to.network],
                [to.token]: (prev.destinationRoutes?.[to.network]?.[to.token] || 0) + 1
            }
        },
    };
};
